import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import _ from "lodash";
import Breadcrumb from "./PageComponent/Breadcrum";
import FilterHeader from "./PageComponent/FilterHeader";
import UpgradePopup from "./PageComponent/UpgradePopup";

export default function PageNavigation(props) {
  const q_data = props.id;
  const [userRole, setUserRole] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  const lastScrollTop = useRef(0);

  useEffect(() => {
    const fetchUserRole = async () => {
      const response = await fetch("/api/check-auth");
      const data = await response.json();
      if (data.success) {
        setUserRole(data.roles);
      }
    };
    fetchUserRole();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = document.documentElement.scrollTop;
      if (scrollTop > 700 && scrollTop > lastScrollTop.current) {
        setShowPopup(true);
      } else if (scrollTop < 400) {
        setShowPopup(false);
      }
      lastScrollTop.current = scrollTop <= 0 ? 0 : scrollTop;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const main_heading = props.heading;
  const lowercasedString = _.toLower(main_heading);
  const stringWithoutSpaces = _.replace(lowercasedString, /\s/g, "");

  const gibberishTitle = "XyZ123 Gibberish Title";

  function Box({ title, no, isLocked, _id }) {
    const displayTitle = isLocked ? gibberishTitle : title;
    
    return (
      <div
        className={`h-36 max-w-6xl bg-gray-100 border-t-2 mx-4 sm:mx-8 md:ml-11 mb-4 relative flex items-center justify-between p-5 sm:p-6 ${isLocked ? 'blur-sm' : ''}`}
        style={{
          userSelect: isLocked ? "none" : "text",
        }}
      >
        <div className="text-sm sm:text-base font-semibold">{no}</div>
        <div className="w-40 sm:w-56 md:w-72 lg:w-96 truncate text-sm sm:text-base ">
          {displayTitle}
        </div>
        <div className="ml-2">
          <span
            className={`${
              isLocked ? "bg-gray-400" : "bg-gradient-to-r from-fuchsia-900 to-fuchsia-700"
            } text-white font-semibold py-2 px-3 rounded-sm text-sm sm:text-base`}
          >
            {isLocked ? "Locked" : "Medium"}
          </span>
        </div>
        <div className="pl-2 sm:pl-6">
          {isLocked ? (
            <p className="text-gray-400 text-sm sm:text-base">Locked</p>
          ) : (
            <Link
              className="nav-link text-sm sm:text-base underline"
              to={`/practice/${stringWithoutSpaces}/${encodeURIComponent(_id)}`}
            >
              Open Question
            </Link>
          )}
        </div>
      </div>
    );
  }

  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(q_data.length / itemsPerPage);
  const maxPagesToShow = 7;
  const halfMaxPages = Math.floor(maxPagesToShow / 2);

  const handleClick = (page) => {
    if (userRole !== 7) setCurrentPage(page);
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else if (currentPage <= halfMaxPages) {
      for (let i = 1; i <= maxPagesToShow; i++) {
        pageNumbers.push(i);
      }
    } else if (currentPage > totalPages - halfMaxPages) {
      for (let i = totalPages - maxPagesToShow + 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      for (let i = currentPage - halfMaxPages; i <= currentPage + halfMaxPages; i++) {
        pageNumbers.push(i);
      }
    }
    return pageNumbers;
  };

  const pageNumbers = getPageNumbers();
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, q_data.length);
  const lockedQuestions = userRole === 7 ? q_data.slice(5) : [];

  return (
    <div>
      <section className="relative top-24 md:left-[290px] bg-gray-100 max-w-6xl py-4 px-4 sm:py-5 sm:px-6 md:px-10 mx-2 sm:mx-4 rounded-sm">
        <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 text-center md:text-start">
          {props.heading}
        </h1>

        <Breadcrumb />
        <FilterHeader />
        {showPopup && userRole === 7 && <UpgradePopup />}

        {q_data.slice(startIndex, endIndex).map((item, index) => (
          <Box
            key={item._id}
            no={startIndex + index + 1}
            title={item.q_title}
            _id={item._id}
            isLocked={lockedQuestions.includes(item)}
          />
        ))}

        <div className="relative max-w-3xl top-16 sm:top-24 mx-auto pt-4 bg-white">
          <ol className={`flex flex-wrap justify-center gap-1 text-xs sm:text-sm font-medium ${userRole === 7 ? "filter blur-sm" : ""}`}>
            {currentPage > 1 && (
              <li>
                <button onClick={() => handleClick(1)} className="inline-flex h-7 w-7 sm:h-8 sm:w-8 items-center justify-center rounded border border-gray-100 bg-white text-gray-900">
                  1
                </button>
              </li>
            )}
            <li>
              <button onClick={() => handleClick(Math.max(currentPage - 1, 1))} className="inline-flex h-7 w-7 sm:h-8 sm:w-8 items-center justify-center rounded border border-gray-100 bg-white text-gray-900">
                Prev
              </button>
            </li>
            {pageNumbers.map((number) => (
              <li key={number}>
                <button onClick={() => handleClick(number)} className={`h-7 w-7 sm:h-8 sm:w-8 rounded border ${number === currentPage ? "bg-gradient-to-r from-fuchsia-900 to-fuchsia-700 text-white" : "bg-white text-gray-900"}`}>
                  {number}
                </button>
              </li>
            ))}
            <li>
              <button onClick={() => handleClick(Math.min(currentPage + 1, totalPages))} className="inline-flex h-7 w-7 sm:h-8 sm:w-8 items-center justify-center rounded border border-gray-100 bg-white text-gray-900">
                Next
              </button>
            </li>
            {currentPage < totalPages && (
              <li>
                <button onClick={() => handleClick(totalPages)} className="inline-flex h-7 w-7 sm:h-8 sm:w-8 items-center justify-center rounded border border-gray-100 bg-white text-gray-900">
                  {totalPages}
                </button>
              </li>
            )}
          </ol>
        </div>
      </section>
    </div>
  );
}
